import React from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

interface PaginationProps {
  totalPages: number;
  currentPage: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  totalPages,
  currentPage,
  onPageChange,
}) => {
  const getPageNumbers = () => {
    const pages: (number | string)[] = [];
  
    const shouldShowLeftEllipsis = currentPage > 3;
    const shouldShowRightEllipsis = currentPage < totalPages - 2;
  
    // Always show first page
    pages.push(1);
  
    // Show left ellipsis if needed
    if (shouldShowLeftEllipsis) {
      pages.push("...");
    }
  
    // Show pages around current page
    const startPage = Math.max(2, currentPage - 1);
    const endPage = Math.min(totalPages - 1, currentPage + 1);
  
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
  
    // Show right ellipsis if needed
    if (shouldShowRightEllipsis) {
      pages.push("...");
    }
  
    // Always show last page if it's more than 1
    if (totalPages > 1) {
      pages.push(totalPages);
    }
  
    return pages;
  };
  

  return (
    <div className="flex justify-end text-[14px] overflow-hidden xs:justify-center items-center mt-6 space-x-2">
  <button
    onClick={() => onPageChange(currentPage - 1)}
    disabled={currentPage === 1}
    className="p-2 rounded-md hover:bg-gray-800 hover:text-white dark:text-white text-black disabled:opacity-50 disabled:cursor-not-allowed"
  >
    <FaChevronLeft />
  </button>

  {getPageNumbers().map((page, index) =>
  typeof page === "number" ? (
    <button
      key={index}
      onClick={() => onPageChange(page)}
      className={`px-3 py-1 rounded-md ${
        currentPage === page
          ? "bg-gray-600 text-white"
          : "hover:bg-gray-800 bg-gray-300 text-black hover:text-white"
      }`}
    >
      {page}
    </button>
  ) : (
    <span key={index} className="px-2 text-black dark:text-white">
      ...
    </span>
  )
)}


  <button
    onClick={() => onPageChange(currentPage + 1)}
    disabled={currentPage === totalPages}
    className="p-2 rounded-md hover:text-white hover:bg-gray-800 dark:text-white text-black disabled:opacity-50 disabled:cursor-not-allowed"
  >
    <FaChevronRight />
  </button>
</div>

  );
};

export default Pagination;
